import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { CesSelectFieldComponent } from '../../../../../../ui/ces-select-field/ces-select-field.component';
import { CesTextFieldComponent } from '../../../../../../ui/ces-text-field/ces-text-field.component';
import { BaseMeasureInfoComponent } from '../../shared/base-measure-info.component';

@Component({
  selector: 'app-manual-measure-info',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CheckboxModule,
    CesSelectFieldComponent,
    CesTextFieldComponent,
    DropdownModule,
    InputTextModule,
    MultiSelectModule,
    ReactiveFormsModule,
    TranslocoModule,
  ],
  templateUrl: './manual-measure-info.component.html',
})
export class ManualMeasureInfoComponent extends BaseMeasureInfoComponent {}
